export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const IS_LOGGIN_IN = "IS_LOGGIN_IN";
